export default __webpack_public_path__ + "static/media/resume.c27be234.pdf";